import { render, staticRenderFns } from "./SearchWatchFields.vue?vue&type=template&id=298181f4&"
import script from "./SearchWatchFields.vue?vue&type=script&lang=js&"
export * from "./SearchWatchFields.vue?vue&type=script&lang=js&"
import style0 from "./SearchWatchFields.vue?vue&type=style&index=0&id=298181f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports